
































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Affix } from 'vue-affix'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    Affix
  }
})
export default class AdminWalletShowSideNavigation extends Vue {
  @Prop() walletAble!: { writer: boolean, user: boolean }

  scrollPageTo(navEl) {
    let element = document.querySelector(`#${navEl}`)
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

}
